import labels from "emun.order/_labels";
import templateUrl from "emun.salesrep/top-selling-products.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";

export class TopSellingProductsController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.labels = labels;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    $ctrl.vendors = [];
    $ctrl.vendorQuery = new AutoQuery({
      url: "QueryVendors.json",
      autoLoad: true,
      take: 1000,
      onLoaded: function (args) {
        args.results.forEach(function (v) {
          $ctrl.vendors.push(v.label);
        });
      },
    });

    var url = "QueryTopSellingProducts.json";
    if ($ctrl.customer) {
      url = url + "?CustomerId=" + $ctrl.customer.id;
    }
    if ($ctrl.rep) {
      url = url + "?RepId=" + $ctrl.rep.id;
    }
    if ($ctrl.vendor && $ctrl.vendor != "ALL") {
      url = url + "?VendorId=" + $ctrl.vendor;
    }

    this.topProducts = new AutoQuery({
      url: url,
      criteria: {
        VendorIdIn: [],
      },
      autoLoad: true,
      pageSize: 10,
      take: 10,
    });
  }
  downloadData() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      $ctrl.topProducts.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
}

export default {
  bindings: {
    collapsed: "=?",
    rep: "<",
    customer: "<",
    context: "@",
    title: "@",
    vendor: "@",
  },
  controller: TopSellingProductsController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
